import CurrencyInput from "react-currency-input-field";

const CurrencyInputField = ({ label, name, formik, reqiuerd }) => {
  return (
    <div className="w-full flex flex-col h-24 relative">
      <label className="mb-2 text-sm" htmlFor={name}>
        {label} {reqiuerd ? <span className="text-red-700">*</span> : ""}
      </label>
      <CurrencyInput
        name={name}
        className="border border-stone-200 h-10 rounded px-2 focus:outline-lightGreenKite"
        decimalSeparator="."
        groupSeparator=","
        value={formik.values[name]}
        onValueChange={(value, name) => {
          formik.setFieldValue(name, value);
        }}
      />
      <div className="absolute top-9 left-2">ریال</div>
      {formik.errors[name] && formik.touched[name] && (
        <div className="text-xs text-orangeKite mt-1">
          {formik.errors[name]}
        </div>
      )}
    </div>
  );
};

export default CurrencyInputField;
